const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时全天候滚动更新，重大热点事件发生后最短时间内即可在平台看到相关报道，永远走在吃瓜第一线。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容严谨',
    desc: '每条资讯均经过编辑团队多方核实与筛选，明确标注信息来源与可信度，杜绝虚假新闻和标题党内容。',
  },
  {
    icon: 'ri-global-line',
    title: '全面覆盖',
    desc: '覆盖明星八卦、综艺热点、网红动态、影视资讯、时尚穿搭等100+内容分类，一个平台满足所有吃瓜需求。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-star-line text-sm"></i>
            平台特色
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm mt-2">为什么选择五一吃瓜网</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 text-center"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </span>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}